import { Close, FilterAlt, FilterList } from "@mui/icons-material";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomTooltip from "../../../utils/CustomTooltip";
import Button3D from "../../../utils/common/3d-button/Button3D";
import MyCheckBox from "../../../utils/common/check-box/MyCheckBox";
import { ISubCategoryView } from "../../categories/models/ICategoryResponseView";
import { primary } from "../../../themes/theme";

/**
 * The Product Sidebar Component Types
 */
interface IProps {
  subCategories: ISubCategoryView[];
  filteredTheProducts: (subsList: ISubCategoryView[]) => void;
  setSubCategories: React.Dispatch<React.SetStateAction<ISubCategoryView[]>>;
  categoryName: string | undefined;
}

/**
 * The Products Sidebar Component
 * @param subCategories
 * @param filteredTheProducts
 * @praram setSubCategories
 * @constructor
 */

const ProductSidebar: React.FC<IProps> = ({
  subCategories,
  filteredTheProducts,
  setSubCategories,
  categoryName,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [profileState, setProfileState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: string, openDrawer: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setProfileState({ ...profileState, [anchor]: openDrawer });
      handleClose();
    };

  /**
   * On Click of apply button
   */
  const clickApply = () => {
    setShow(false);
    filteredTheProducts(subCategories);
  };

  /**
   * To update check from nested component
   * @param event
   * @param id
   */
  const updateChecks = (
    event: React.ChangeEvent<HTMLInputElement> | any,
    id: string | undefined
  ) => {
    if (id) {
      setSubCategories(
        subCategories.map((item) => {
          if (item._id === id) {
            return {
              ...item,
              isChecked: event.target.checked,
            };
          }
          return item;
        })
      );
    }
  };

  return (
    <>
      <Box>
        <CustomTooltip title="Filters">
          <IconButton
            // ref={filterAnchorRef}
            onClick={() => handleShow()}
            sx={{ color: "grey", "&:hover": { color: primary[900] } }}
          >
            <FilterList />
          </IconButton>
        </CustomTooltip>

        <SwipeableDrawer
          anchor="right"
          open={show}
          onClose={toggleDrawer("left", false)}
          onOpen={toggleDrawer("left", true)}
          sx={{
            zIndex: 1300,
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 333,
              background: "#ffffff",
              backdropFilter: "blur(50px)",
            },
          }}
          PaperProps={{
            sx: { borderRadius: "5px 0px 0px 5px", background: "#ffffff" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
              py: 1,
              pl: 3,
            }}
          >
            <Box>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Ubuntu",
                  color: primary[900],
                  textTransform: "uppercase",
                }}
              >
                {categoryName}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "550",
                  fontFamily: "Ubuntu",
                  color: primary[600],
                  textTransform: "captilaize",
                }}
              >
                Filters & Sorting
              </Typography>
            </Box>
            <IconButton
              onClick={handleClose}
              sx={{
                background: "transparent",
                color: "grey",
                mr: 1,
                "&:hover": {
                  background: "transparent",
                  color: primary[900],
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider sx={{ background: primary[500] }} variant="middle" />
          <Box sx={{ display: "flex", justifyContent: "flex-start", pl: 3 }}>
            {subCategories &&
              Array.isArray(subCategories) &&
              subCategories.length > 0 && (
                <List>
                  {subCategories &&
                    subCategories.map((subCategory: ISubCategoryView) => {
                      return (
                        <ListItem
                          key={subCategory._id}
                          sx={{
                            color: primary[500],
                            fontWeight: "500",
                            fontFamily: "Ubuntu",
                            fontSize: "14px",
                            my: 1,
                          }}
                        >
                          <FormControl>
                            <FormControlLabel
                              control={
                                <MyCheckBox
                                  checked={subCategory.isChecked}
                                  onChange={(e) =>
                                    updateChecks(e, subCategory._id)
                                  }
                                  ariaLabel={subCategory.name}
                                  name={subCategory.name}
                                />
                              }
                              label={subCategory.name}
                            />
                          </FormControl>
                        </ListItem>
                      );
                    })}
                </List>
              )}
          </Box>
          <Box sx={{ pl: 3 }}>
            {/* <MyButton buttonText="Apply Filters" onClick={clickApply} /> */}
            <Button3D
              buttonText="Apply Filters"
              onClick={clickApply}
              buttonIcon={<FilterAlt sx={{ pr: "5px", pt: "5px" }} />}
            />
          </Box>
        </SwipeableDrawer>
      </Box>
    </>
  );
};

export default ProductSidebar;
